import { BaseCurtain } from '../constants/productTypes';
import { ProductBuilderMachineContext } from '../types';

export const isCurtain = ({ products }: ProductBuilderMachineContext) => {
  const curtainsProductType: BaseCurtain = 'Curtain';

  return products[0].type.includes(curtainsProductType);
};

export const isSheer = ({ products }: ProductBuilderMachineContext) => {
  const luxurySheerProductType: BaseCurtain = 'Sheer Curtain';

  return products[0].type.includes(luxurySheerProductType);
};
